export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  REMOVE_SIDEMENU_COOKE: 'REMOVE_SIDEMENU_COOKE',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  WHATSAPP_PAIR_COMPLETED: 'whatsappPairCompleted',
  WHATSAPP_PRE_PAIR: 'whatsappPrePair',
  WHATSAPP_SYNC_CONTACT_COMPLETED: 'whatsappSyncContactCompleted',
  WHATSAPP_SYNC_LABEL_COMPLETED: 'whatsappSyncLabelCompleted',
  WHATSAPP_RECONNECT_FINISH: 'whatsappReconnectFinish',
  TELEGRAM_QR_SCAN: 'telegramQrScan',
  CHANNEL_CREATED: 'channelCreated',
  INBOX_AND_CHANNEL_CREATED: 'inboxAndChannelCreated',
  BASALAM_INBOX_CREATED: 'basalamInboxCreated',
  MESSAGE_HIGHLIGHT: 'messageHighlight',
  CONTACT_IMPORT_FILE_FINISHED: 'contact_import_file_finished',
  CONTACT_EXPORT: 'contact_export'
};
